<script setup lang="ts">
import {
  SelectItem,
  SelectItemIndicator,
  type SelectItemProps,
  SelectItemText,
} from 'radix-vue';
import { Check } from 'lucide-vue-next';
import { cn } from '../lib/utils';

const props = defineProps<SelectItemProps & { class?: string }>();
</script>

<template>
  <SelectItem
    v-bind="props"
    :class="
      cn(`
        relative flex w-full cursor-default select-none items-center gap-8 py-8 px-8
        text-sm outline-none data-[disabled]:pointer-events-none
        data-[disabled]:opacity-50
        text-[color:var(--theme-text-color)]
        hover:bg-[color:var(--popper-hover-background-color)]
        hover:text-[color:var(--popper-hover-text-color)]
        hover:cursor-pointer`,
         props.class,
      )
    "
  >
    <div class="inline-flex shrink-0 basis-8 items-center justify-center">
      <SelectItemIndicator>
        <Check class="w-16" />
      </SelectItemIndicator>
    </div>

    <SelectItemText class="min-w-0 flex-1 whitespace-normal break-words leading-snug">
      <slot />
    </SelectItemText>
  </SelectItem>
</template>
